var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddFile = function SvgAddFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M12.397 19.379V8.323l5.727 5.12c.396.355 1.039.355 1.434 0 .397-.356.397-.933 0-1.289l-7.49-6.7c-.395-.355-1.038-.355-1.433 0l-.006.006c-.027.02-.05.043-.074.065l-7.41 6.63c-.396.355-.396.932 0 1.289.396.354 1.039.354 1.434 0l5.695-5.092v11.027c0 .522.477.944 1.061.944.587 0 1.062-.422 1.062-.944z",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 1,
    x: 2,
    y: 3,
    fill: "#ED1C24",
    stroke: "#ED1C24",
    rx: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_file.16a0eca5.svg";
export { ForwardRef as ReactComponent };